// extracted by mini-css-extract-plugin
export default {"usage":"Usage_usage__ozQMK","content":"Usage_content__6lCeg","title":"Usage_title__D9kfr","value":"Usage_value__bXkI0"};